import useFirebaseData from "./useFirebaseData";
import type { FirebaseRecord, Firing } from "../types";

const useFirebaseTemplateFirings = (glass_type: string) => {
  return useFirebaseData<FirebaseRecord<Firing>>(glass_type ? `/templates/firings/${glass_type}` : null);
};

export default useFirebaseTemplateFirings;
